import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { icons, images, videos } from "../../assets";
import { allColors } from "../../constants";
import GlobalButton from "./../../components/globalButton/index";
import { mediaUrl } from "../../constants/variables";
// import ReactPlayer from "react-player";

const sliderData = [
  {
    id: 1,
    title: "Digital Phone Line",
    description: "Make & receive calls on your device.Pay as you go",
    price: "£16.99",
    bgColor: "linear-gradient(to right, #1f75fe, #cde1ff)",
    sideImge: images.bannerImg1New,
    respImg: images.bannerOneResp,
    // sideImge: `${mediaUrl}Q0sVwu77VZiBfile_example_MOV_1920_2_2MB.mov`,
    // sideImge:
    //   "https://res.cloudinary.com/dm1oz1xpd/video/upload/v1726476742/Preview_Compress_1_cnggnq.mp4",
    cornerText: "Only pay for what you use",
    cornerCircleColor: "#ffda7a",
    uniqueId: "phone-only",
    showVideo: false,
  },
  {
    id: 2,
    title: "Fibre Broadband",
    description: "Unlimited internet. Speeds of up to 40 Mbps",
    price: "£34.99",
    bgColor: "linear-gradient(to right, #ffda7a, #ededed)",
    sideImge: images.bannerImg2,
    respImg: images.bannerTwoResp,
    // sideImge:
    //   // videos.video2,
    //   "https://res.cloudinary.com/dm1oz1xpd/video/upload/v1726479790/Router_zddvmq.mp4",
    cornerText: "Get our fastest speeds available",
    cornerCircleColor: "#ff914d",
    uniqueId: "broadband-only",
    showVideo: false,
  },
  {
    id: 3,
    title: "Fibre & Phone",
    description:
      "Unlimited Internet, UK Landline & Mobile calls. Free handset & router.",
    price: "£41.99",
    bgColor: "linear-gradient(to right, #ff914d, #fae3c7)",
    sideImge: images.bannerImg3,
    respImg: images.bannerImg3,
    // sideImge: videos.video3,
    cornerText: "Bundle for our best value",
    cornerCircleColor: "#7baeff",
    uniqueId: "phone-broadband",
    showVideo: false,
  },
];

const BannerSection = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleRenderIndicator = (handler, isActive) => {
    return (
      <button
        style={{
          height: "18px",
          width: "18px",
          border: `1px solid ${allColors.lightBlack}`,
          borderRadius: "50%",
          marginRight: "20px",
          cursor: "pointer",
          background: isActive ? allColors.jetBlack : "none",
        }}
        onClick={handler}
      ></button>
    );
  };

  return (
    <Container
      sx={{
        maxWidth: "1300px !important",
        marginTop: "80px",
        position: "relative",
        "& > .carousel-root > .carousel-slider": {
          overflow: "visible",
        },
        "& > .carousel-root > .carousel-slider .control-dots": {
          textAlign: "center",
          bottom: "-60px",
        },
      }}
    >
      {/* <div
              className={`${
                hasPrev ? "absolute" : "hidden"
              } top-0 bottom-0 left-0 flex justify-center items-center p-3 opacity-30 hover:opacity-100 cursor-pointer z-20`}
              onClick={clickHandler}
            >
              <LeftIcon className="w-9 h-9 text-white" />
            </div> */}
      <Carousel
        autoPlay={true}
        interval={4000}
        infiniteLoop={true}
        showStatus={false}
        showIndicators={true}
        useKeyboardArrows={true}
        preventMovementUntilSwipeScrollTolerance
        swipeScrollTolerance={100}
        renderIndicator={handleRenderIndicator}
        renderArrowPrev={(clickHandler, hasPrev) => {
          return (
            <button
              onClick={clickHandler}
              style={{
                width: isSmallScreen ? "30px" : "40px",
                height: isSmallScreen ? "30px" : "40px",
                top: isSmallScreen ? "50%" : "55%",
                left: isSmallScreen ? "-15px" : "-20px",
                cursor: "pointer",
                position: "absolute",
                zIndex: 99,
                background: "white",
                border: "none",
                borderRadius: "50%",
                padding: 0,
                margin: 0,
              }}
            >
              <img
                src={
                  hasPrev
                    ? icons.carouselLeftArrowDark
                    : icons.carouselLeftArrowLight
                }
                style={{
                  width: "100%",
                  height: "100%",
                  //   position: hasPrev ? "absolute" : "hidden",
                }}
                onClick={clickHandler}
              />
            </button>
          );
        }}
        renderArrowNext={(clickHandler, hasNext) => {
          return (
            <button
              onClick={clickHandler}
              style={{
                position: "absolute",
                right: isSmallScreen ? "-15px" : "-20px",
                zIndex: 99,
                top: isSmallScreen ? "50%" : "55%",
                width: isSmallScreen ? "30px" : "40px",
                height: isSmallScreen ? "30px" : "40px",
                cursor: "pointer",
                background: "white",
                border: "none",
                borderRadius: "50%",
                padding: 0,
                margin: 0,
              }}
            >
              <img
                src={
                  hasNext
                    ? icons.carouselRightArrowDark
                    : icons.carouselRightArrowLight
                }
                style={{
                  width: "100%",
                  height: "100%",
                  //   position: hasPrev ? "absolute" : "hidden",
                }}
              />
            </button>
          );
        }}
      >
        {sliderData.map((itemmmmm, indddd) => {
          return (
            <Box
              sx={{
                backgroundImage: itemmmmm.bgColor,
                borderRadius: "35px",
                marginTop: "60px",
                padding: "30px 0px 0px 0px",
                // height: { xs: "auto", md: "500px" },
              }}
            >
              <Box
                sx={{
                  background: itemmmmm.cornerCircleColor,
                  borderRadius: "50%",
                  width: { xs: "100px", md: "140px" },
                  height: { xs: "100px", md: "140px" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "15px",
                  position: "absolute",
                  left: { xs: false, sm: "30px" },
                  right: { xs: "0px", sm: false },
                  top: { xs: "30px", sm: "0" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "14px", md: "19px" },
                    color: allColors.jetBlack,
                    fontFamily: "Raleway",
                    fontWeight: "600",
                    lineHeight: "normal",
                  }}
                >
                  {itemmmmm.cornerText}
                </Typography>
              </Box>

              {indddd == 2 ? (
                <Typography
                  sx={{
                    fontSize: { xs: "40px", md: "65px" },
                    color: allColors.jetBlack,
                    fontFamily: "Raleway",
                    fontWeight: "600",
                    marginTop: "15px",
                    lineHeight: { xs: "40px", sm: "80px" },
                    textAlign: "left",
                    display: { xs: "block", sm: "none" },
                    marginLeft: "28px",
                    width: "70%",
                  }}
                >
                  Fibre <br /> & Phone
                </Typography>
              ) : (
                <Typography
                  sx={{
                    fontSize: { xs: "40px", md: "65px" },
                    color: allColors.jetBlack,
                    fontFamily: "Raleway",
                    fontWeight: "600",
                    marginTop: "15px",
                    lineHeight: { xs: "40px", sm: "80px" },
                    textAlign: "left",
                    display: { xs: "block", sm: "none" },
                    marginLeft: "28px",
                    width: "70%",
                  }}
                >
                  {itemmmmm.title}
                </Typography>
              )}
              <Grid
                container
                spacing={{ xs: indddd == 0 ? 0 : 2, md: 3 }}
                alignItems={{ xs: "flex-start", sm: "center" }}
                sx={{
                  padding: { xs: "30px 20px 10px", md: "0px 40px" },
                }}
              >
                <Grid item xs={5.5} sm={6} textAlign={"left"} mb={3}>
                  <Typography
                    sx={{
                      fontSize: { sm: "35px", md: "65px" },
                      color: allColors.jetBlack,
                      fontFamily: "Raleway",
                      fontWeight: "600",
                      marginTop: { xs: "0px", sm: "20px" },
                      lineHeight: { xs: "55px", sm: "80px" },
                      textAlign: "left",
                      display: { xs: "none", sm: "block" },
                    }}
                  >
                    {itemmmmm.title}
                  </Typography>
                  <Typography
                    sx={{
                      marginLeft: { xs: "14px", sm: 0 },
                    }}
                  >
                    {itemmmmm.description.split(".").map((sentence, index) => (
                      <Typography
                        sx={{
                          fontSize: { xs: "16px", sm: "23px" },
                          color:
                            indddd == 1 || indddd == 2
                              ? allColors.jetBlack
                              : allColors.white,
                          fontWeight: "500",
                          fontFamily: "Raleway",
                          lineHeight: { xs: "21px", sm: "30px" },
                          marginTop: {
                            xs: index == 1 && "8px",
                            sm: 0,
                          },
                          display: indddd == 2 && index == 2 ? "none" : "block",
                        }}
                      >
                        {sentence}.
                      </Typography>
                    ))}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Squad-Regular",
                      fontSize: { xs: "40px", md: "60px" },
                      color: allColors.jetBlack,
                      fontWeight: "700",
                      marginLeft: { xs: "14px", sm: 0 },
                      marginTop: {
                        xs: indddd == 2 ? 0 : "20px",
                        sm: indddd == 2 ? "20px" : 0,
                      },
                      lineHeight: {
                        xs: "35px",
                        sm: indddd == 2 ? "35px" : "85px",
                      },
                    }}
                  >
                    {itemmmmm.price}
                    {!isSmallScreen && (
                      <span
                        style={{
                          fontSize: isSmallScreen ? "11px" : "18px",
                          textAlign: "right",
                        }}
                      >
                        p/m
                      </span>
                    )}
                  </Typography>
                  {isSmallScreen && (
                    <Typography
                      style={{
                        fontSize: "11px",
                        textAlign: "right",
                        marginRight: "10px",
                      }}
                    >
                      p/m
                    </Typography>
                  )}
                </Grid>
                <Grid
                  item
                  xs={6.5}
                  sm={6}
                  textAlign={"center"}
                  // display={{ xs: "none", sm: "block" }}
                >
                  {itemmmmm.showVideo ? (
                    <video
                      autoPlay
                      muted
                      loop
                      src={itemmmmm.sideImge}
                      style={{ width: "100%", height: "100%" }}
                      controls={false}
                    />
                  ) : (
                    // <ReactPlayer
                    //   url={itemmmmm.sideImge}
                    //   style={{ width: "100%", height: "100%" }}
                    //   loop
                    //   controls
                    //   playing={true}
                    //   autoPlay={true}
                    // />
                    <img
                      src={isSmallScreen ? itemmmmm.respImg : itemmmmm.sideImge}
                      style={{
                        // width: "100%",
                        width:
                          indddd == 0 && isSmallScreen
                            ? "82%"
                            : isSmallScreen
                            ? "100%"
                            : "auto",
                        height: isSmallScreen ? "100%" : "400px",
                        // height: isSmallScreen ? "150px" : "100%",
                        margin: "0 auto",
                      }}
                      alt={itemmmmm.sideImge}
                    />
                  )}
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: { xs: "90%", sm: "35%" },
                  paddingBottom: "20px",
                  margin: { xs: "0 auto", sm: "20px 0 20px 20px" },
                }}
              >
                <a
                  href={"#contact-us"}
                  style={{ width: "100%", marginRight: "10px" }}
                >
                  <GlobalButton
                    title={"Switch today"}
                    style={{
                      background: allColors.white,
                      color: allColors.jetBlack,
                      borderRadius: "10px",
                      height: { xs: 40, sm: 50 },
                      px: { xs: "15px", sm: "22px" },
                      width: "100%",
                    }}
                  />
                </a>
                <a href={`#${itemmmmm.uniqueId}`} style={{ width: "100%" }}>
                  <GlobalButton
                    title={"Show more"}
                    style={{
                      background: "none",
                      borderRadius: "30px",
                      height: { xs: 40, sm: 50 },
                      px: { xs: "15px", sm: "22px" },
                      border: `1px solid ${
                        indddd == 0 ? allColors.white : allColors.jetBlack
                      }`,
                      color: indddd == 0 ? allColors.white : allColors.jetBlack,
                      width: "100%",
                    }}
                  />
                </a>
              </Box>
            </Box>
          );
        })}
      </Carousel>
    </Container>
  );
};

export default BannerSection;
